import { SvgIconProps } from "../types";

export const SvgIcon = ({ src, width, height }: SvgIconProps) => (
  <img
    src={`/img/svg/${src}`}
    alt=""
    width={width}
    height={height}
    loading="lazy"
    decoding="async"
    aria-hidden="true"
  />
);
